import { RouteConfig, Route } from 'vue-router';
import { RouterPath } from '../shared/enums';
import store from '../store';
import queryString from 'query-string';
import { CallbackToken } from '../store/auth/types';
import { AuthenticationService } from '../modules/authentication/services/authentication.service';

const callbackLogin = (to: Route, next) => {
    const callbackToken = {
        access_token: AuthenticationService.token
    } as CallbackToken;

    store.dispatch('auth/login', callbackToken).then(response => {
        next({ path: RouterPath.HOME, replace: true });
    }).catch(error => {
        next({ path: RouterPath.ERROR, replace: true });
    });
};

export default (): Array<RouteConfig> => {
    return [{
        path: RouterPath.AUTH_LOGIN,
        meta: {loginPage: true, nonRequiresAuth: true},
        beforeEnter(to, from, next) {
            callbackLogin(to, next);
        }
    },
    {
        path: RouterPath.AUTH_CALLBACK,
        meta: {nonRequiresAuth: true},
        beforeEnter(to, from, next) {
            callbackLogin(to, next);
        }
    },
    {
        path: RouterPath.AUTH_LOGOUT,
        component: () => import('./components/pages/page-logout').then(m => m.default),
        meta: {nonRequiresAuth: true}
    },
    {
        path: RouterPath.AUTH_SWITCH_WORKSPACE,
        component: () => import('./components/pages/page-switch-workspace').then(m => m.default)
    }];
};
